/* eslint-disable import/no-cycle */
/* eslint-disable no-bitwise */
import angular from 'angular';
import { detect } from 'detect-browser';
import { RootScope } from '../../app.config';
import { UserLoginStatistics } from '../../src/app/@shared-types/admin/statistics';
import { LocalStorageService } from './local-storage.service';

/* @ngInject */
export class BrowserStatisticsService {
  private $rootScope: RootScope;

  private localStorageService: LocalStorageService;

  constructor(
    $rootScope: RootScope,
    localStorageService: LocalStorageService,
  ) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.localStorageService = localStorageService;
  }

  public init = (): void => {
    this.initDeviceId();
  };

  private generateDeviceId = (parts: number): string => {
    const stringArr = [];
    for (let i = 0; i < parts; i += 1) {
      const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      stringArr.push(S4);
    }
    return stringArr.join('-');
  };

  /** Set a unique id for current device and save it to local storage.
   * Skip, if id was already set. */
  public initDeviceId = (): void => {
    if (!this.$rootScope.globals.deviceId) {
      this.$rootScope.globals.deviceId = this.generateDeviceId(4);
    }
  };

  private getDeviceId = (): string => this.$rootScope.globals.deviceId || 'undefined';

  public getStatistics = (): UserLoginStatistics => {
    const browser = detect();
    return {
      browser: `${browser?.name}_${browser?.version}` || 'undefined',
      deviceId: this.getDeviceId(),
      os: browser?.os || 'undefined',
    };
  };
}

export default angular.module('browserStatisticsService', [])
  .service('browserStatisticsService', BrowserStatisticsService)
  .name;
